import React, { ReactNode } from 'react';
import ErrorBoundary from '../shared/ErrorBoundary';

export const ItpSubbieErrorBoundary = ({ children }: { children?: ReactNode }) => (
  <ErrorBoundary category="itp-subbie">{children}</ErrorBoundary>
);
